// Pure utility functions for credit calculations
// Functional, side-effect free, and input-safe

const toNumber = (value) => {
  const n = Number(value);
  return Number.isFinite(n) ? n : 0;
};

// Calculates available credit limit across prepaid + remaining credit
// available = topUpBalance + max(creditLimit - creditUsed, 0)
export const calculateAvailableCreditLimit = ({
  topUpBalance = 0,
  creditLimit = 0,
  creditUsed = 0,
} = {}) => {
  const topUp = toNumber(topUpBalance);
  const limit = toNumber(creditLimit);
  const used = toNumber(creditUsed);
  return topUp + Math.max(0, limit - used);
};

// Calculates credit utilization percentage (0-100)
// utilization = creditUsed / creditLimit
export const calculateCreditUtilization = ({
  creditLimit = 0,
  creditUsed = 0,
} = {}) => {
  const limit = toNumber(creditLimit);
  const used = toNumber(creditUsed);
  if (limit <= 0) return 0;
  return (used / limit) * 100;
};

// Optionally derive creditUsed from orders list
// Sums order.totalAmount safely
export const sumOrdersTotal = (orders = []) => {
  if (!Array.isArray(orders)) return 0;
  return orders.reduce((sum, o) => sum + toNumber(o?.totalAmount), 0);
};

const creditUtils = {
  calculateAvailableCreditLimit,
  calculateCreditUtilization,
  sumOrdersTotal,
};

export default creditUtils;
